import {createAxiosInstance} from './base.api'

const categoryApi = 'categories'

export const getAllCategories = (successMethod, errorMethod) => createAxiosInstance(categoryApi).get('/')
.then(response => successMethod(response))
.catch(error => errorMethod(error))


export const getCategory = (id) => createAxiosInstance(categoryApi).get(`/${id}`)

export const getCategoryWithProjects = (id, category) => createAxiosInstance(categoryApi).get(`/${id}/projects-details`, category)

export const createCategory = (category) => createAxiosInstance(categoryApi).post('/', category)

export const deleteCategory = (id) => createAxiosInstance(categoryApi).delete(`/${id}`)

export const updateCategory = (id, category) => createAxiosInstance(categoryApi).put(`/${id}/`, category)